/*
 *
 * Page: `@dbh/view-invoices-payment-page`.
 *
 */const importViewInvoicesPaymentPage=()=>import('./component-eb0cb4aa.js'/*  webpackChunkName: 'dbh.wiew-invoices-payment-page.component' */);const importViewInvoicesPaymentPageReducersAndSagas=()=>import('./reducers-and-sagas-077175e6.js'/*  webpackChunkName: 'dbh.view-invoices-payment--page.reducers-and-sagas' */);

export { importViewInvoicesPaymentPage, importViewInvoicesPaymentPageReducersAndSagas };
